export default __webpack_public_path__ + "static/media/new-knowledge.65b5c741.svg";